export enum AlignmentTypes {
  Left = 'left',
  Right = 'right',
  Center = 'center',
  Justify = 'justify',
}
